import { useParams } from 'react-router-dom'
import JourneyDetailView from '../components/JourneyDetailView'
import { useEmbedded } from '../lib/embed'

// Journey page used by both route trees: the full app (`/projects/*`, AppShell sidebar layout) and
// the embeddable `/p/*` iframe (EmbeddedShell layout). Both render the same JourneyDetailView; the
// layout is supplied by the route's shell, and `embedded` toggles the chrome-free in-page styling.
export default function JourneyDetail() {
  const { projectId, journeyId } = useParams<{ projectId: string; journeyId: string }>()
  const embedded = useEmbedded()

  if (!projectId || !journeyId) {
    return embedded ? (
      <div className="embedded-error" role="alert">Journey not found.</div>
    ) : (
      <div className="journey-detail__error" role="alert">Journey not found.</div>
    )
  }

  return (
    <JourneyDetailView
      projectId={projectId}
      journeyId={journeyId}
      basePath={`/projects/${projectId}`}
      embedded={embedded}
    />
  )
}
